import { Grid, Typography } from '@deere/fuel-react';
import { DateTime } from 'luxon';
import { JOB_PHASE, JOB_STATUS } from '../constants.js';
import styles from './JobDetails.module.css';
import { CancelJobModal } from './admin-modals/CancelJobModal.jsx';

export const JobDetails = (props) => {
    const bid = props.bidObj;
    const numberOfRevokedBidders = bid.assignmentList
        ? bid.assignmentList.filter((item) => {
              return item.assignmentType === 'REVOKED';
          }).length
        : 0;
    const numberOfNoQualifiedBidders = bid.assignmentList
        ? bid.assignmentList.filter((item) => {
              return item.assignmentType === 'NO_QUALIFIED_BIDDER';
          }).length
        : 0;

    return (
        <Grid container spacing={4} className={styles.bidGridSection}>
            <Grid item sm={8}>
                <Typography fontWeight="700" variant="h2" color="#000000">
                    {bid.classification.classification} - Department:{' '}
                    {bid.department}
                </Typography>
            </Grid>
            {bid.status === JOB_STATUS.PENDING &&
                bid.jobPhase === JOB_PHASE.CLOSED && (
                    <Grid item sm={4} justifyContent="flex-end" display="flex">
                        <CancelJobModal jobObj={bid} />
                    </Grid>
                )}
            <Grid className={styles.gridSpan} item sm={12}>
                <span>{bid.facility ?? bid.businessUnit?.displayName}</span>
                <span>Pay Level {bid.jobGrade}</span>
                <span>CIPP - {bid.cipp ? 'Yes' : 'No'}</span>
                <span>CIPP {bid.cippPerc}%</span>
            </Grid>
            <Grid className={styles.gridSpan} item sm={12}>
                <span>
                    Posted{' '}
                    {bid.postingStartDate
                        ? DateTime.fromISO(bid.postingStartDate).toFormat(
                              'LL/dd/yy'
                          )
                        : ''}{' '}
                </span>
                <span>
                    Close Date{' '}
                    {bid.endDate
                        ? DateTime.fromISO(bid.endDate).toFormat('LL/dd/yy')
                        : ''}{' '}
                </span>
                <span>
                    Bid Withdrawal Close{' '}
                    {bid.withdrawalEndDate
                        ? DateTime.fromISO(bid.withdrawalEndDate).toFormat(
                              'LL/dd/yy'
                          )
                        : ''}
                </span>
            </Grid>
            {bid.additionalDetails && (
                <Grid item sm={12}>
                    {bid.additionalDetails}
                </Grid>
            )}

            <Grid item sm={4}>
                <div>
                    <span className={styles.bidData}>Qualifications: </span>
                    <span>{bid.qualifications}</span>
                </div>
                <div>
                    <span className={styles.bidData}>
                        Number of Total Openings:
                    </span>
                    <span data-testid="number-of-openings">
                        {bid.noOfOpenings}
                    </span>
                </div>
                <div>
                    <span className={styles.bidData}>
                        Number of Revoked Openings:
                    </span>
                    <span data-testid="number-of-revoked-bidders">
                        {numberOfRevokedBidders}
                    </span>
                </div>
                <div>
                    <span className={styles.bidData}>
                        Number of Openings without Qualified Bidders:
                    </span>
                    <span data-testid="number-of-no-qualified-bidders">
                        {numberOfNoQualifiedBidders}
                    </span>
                </div>
                <div>
                    <span className={styles.bidData}>Supervisor(s): </span>
                    <span>{bid.supervisors}</span>
                </div>
                <div>
                    <span className={styles.bidData}>
                        Over time percentage:{' '}
                    </span>
                    <span>{bid.otPerc}%</span>
                </div>
                <div>
                    <span className={styles.bidData}>Green Line: </span>
                    <span>{bid.greenLine}</span>
                </div>
                <div>
                    <span className={styles.bidData}>Req Number: </span>
                    <span>{bid.reqNumber}</span>
                </div>
            </Grid>
            <Grid item sm={4}>
                <div>
                    <span className={styles.bidData}>
                        Junior Permanent Seniority 1st:{' '}
                    </span>
                    <span>
                        {bid.seniority1
                            ? DateTime.fromISO(bid.seniority1).toFormat(
                                  'LL/dd/yy'
                              )
                            : ''}
                    </span>
                </div>
                <div>
                    <span className={styles.bidData}>
                        Junior Permanent Seniority 2nd:{' '}
                    </span>
                    <span>
                        {bid.seniority2
                            ? DateTime.fromISO(bid.seniority2).toFormat(
                                  'LL/dd/yy'
                              )
                            : ''}
                    </span>
                </div>
                <div>
                    <span className={styles.bidData}>
                        Junior Permanent Seniority 3rd:{' '}
                    </span>
                    <span>
                        {bid.seniority3
                            ? DateTime.fromISO(bid.seniority3).toFormat(
                                  'LL/dd/yy'
                              )
                            : ''}
                    </span>
                </div>
            </Grid>
            <Grid item sm={4}></Grid>
        </Grid>
    );
};
